import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/welcome',
			name: 'SplashScreen',
			component: () => import(/* webpackChunkName: "Dashboard" */ '@/views/SplashScreen'),
		},
		{
			path: '/login',
			name: 'Login',
			component: () => import(/* webpackChunkName: "Dashboard" */ '@/views/Login'),
		},
		{
			path: '/forgot-password',
			name: 'ForgotPassword',
			component: () => import(/* webpackChunkName: "Dashboard" */ '@/views/ForgotPassword'),
		},
		{
			path: '/reset-password/:code',
			name: 'ResetPassword',
			component: () => import(/* webpackChunkName: "Dashboard" */ '@/views/ForgotPasswordReset'),
		},
		{
			path: '/register',
			name: 'Register',
			component: () => import(/* webpackChunkName: "Dashboard" */ '@/views/Register'),
		},
		{
			path: '/logout',
			name: 'Logout',
			component: () => import(/* webpackChunkName: "Dashboard" */ '@/views/Logout'),
		},

		{
			path: '/sell',
			name: 'Sell',
			meta: {
				requiresAuth: true,
			},
			component: () => import(/* webpackChunkName: "Dashboard" */ '@/views/Sell'),
		},
		{
			path: '/sells-history',
			name: 'SellHistory',
			meta: {
				requiresAuth: true,
			},
			component: () => import(/* webpackChunkName: "Dashboard" */ '@/views/SellHistory'),
		},
		{
			path: '/profile',
			name: 'User',
			meta: {
				requiresAuth: true,
			},
			component: () => import(/* webpackChunkName: "Dashboard" */ '@/views/UserForm'),
		},
		{
			path: '/conditions',
			name: 'Conditions',
			component: () => import(/* webpackChunkName: "Dashboard" */ '@/views/Conditions'),
		},
		{
			path: '/',
			name: 'Dashboard',
			meta: {
				requiresAuth: true,
			},
			component: () => import(/* webpackChunkName: "Dashboard" */ '@/views/Home'),
		},

		{
			path: '*',
			redirect: '/',
		},
	],
})

router.beforeEach((to, from, next) => {
	var loggedIn = localStorage.getItem('logged-lgapp')
	loggedIn = JSON.parse(loggedIn)
	if (to.matched.some((record) => record.meta.requiresAuth)) {
		if (loggedIn) {
			next()
			return
		}
		next('/welcome')
	} else {
		next()
	}
})

export default router
